import { useAtom } from '@reatom/npm-react'
import { useRef } from 'react'
import styled from 'styled-components'

import { useHapticFeedback } from '@blade/ui-kit'
import { useAppRoutes } from '@root/features/routing'
import { showDemoScreenAtom } from '@root/shared'
import { useTranslation } from '@root/shared/localization'
import { LogoGlass } from '@root/shared/ui-kit/icons/logo-glass'

export const HeaderBrand = () => {
  const { t } = useTranslation()
  const haptics = useHapticFeedback()
  const { navigateToRoot } = useAppRoutes()

  const [_, setShowDemoScreen] = useAtom(showDemoScreenAtom)
  const demoRef = useRef({ taps: 0, timeoutId: 0 })

  const handleClick = () => {
    haptics.impactOccurred('light')
    navigateToRoot()

    demoRef.current.taps += 1
    if (demoRef.current.taps > 3) {
      setShowDemoScreen(true)
    }

    clearTimeout(demoRef.current.timeoutId)
    demoRef.current.timeoutId = window.setTimeout(() => {
      demoRef.current.taps = 0
    }, 300)
  }

  return (
    <Root onClick={handleClick}>
      <LogoGlass size={30} />
      <BrandName>{t('app.name')}</BrandName>
    </Root>
  )
}
const BrandName = styled.span`
  font-size: 14px;
  font-weight: 600;
`

const Root = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`
